interface QuickRepliesProps {
  onSelect: (text: string) => void;
  disabled?: boolean;
  variant?: 'funcionarios' | 'oposiciones';
}

const funcionariosReplies = [
  { id: 1, text: 'Tengo una consulta' },
  { id: 2, text: 'Quiero redactar un documento' },
  { id: 3, text: 'Buscar jurisprudencia' },
];

const oposicionesReplies = [
  { id: 1, text: 'Hacer examen tipo test' },
  { id: 2, text: 'Hacer caso práctico' },
  { id: 3, text: 'Resolver dudas' },
];

export function QuickReplies({ onSelect, disabled, variant = 'funcionarios' }: QuickRepliesProps) {
  const quickReplies = variant === 'oposiciones' ? oposicionesReplies : funcionariosReplies;

  return (
    <div className="flex justify-center gap-2 px-4 pb-2 flex-wrap">
      {quickReplies.map((reply) => (
        <button
          key={reply.id}
          onClick={() => !disabled && onSelect(reply.text)}
          disabled={disabled}
          className={`flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
            reply.text === 'Buscar jurisprudencia'
              ? 'bg-[#002B5B] text-white hover:bg-[#002B5B]/90'
              : 'bg-[#E2F1EF] text-[#002B5B] hover:bg-[#06D3AA]/20'
          }`}
        >
          {reply.text}
        </button>
      ))}
    </div>
  );
}
